export default __webpack_public_path__ + "static/media/VASNAP_Site_Logo.16f04a56.png";